export default function ReviewSection() {
  return (
    <section className="py-16 md:py-20 lg:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-3">
          <span className="w-2 h-2 rounded-full bg-accent-500"></span>
          <span className="text-xs font-medium text-foreground-500 uppercase tracking-wider">
            Trusted by Sellers
          </span>
        </div>
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight">
          Real Reviews From
          <br />
          Global Sourcing Users
        </h2>
        <p className="text-sm text-foreground-500 mt-3 max-w-lg">
          See how resellers are scaling with itaobuyspreadsheet
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mt-10">
          <div className="bg-background-50 rounded-xl p-6 border border-background-200/60">
            <div className="flex items-center gap-0.5 mb-4">
              {[...Array(5)].map((_, i) => (
                <i
                  key={i}
                  className="ri-star-fill text-accent-500 w-4 h-4 flex items-center justify-center text-sm"
                ></i>
              ))}
            </div>
            <h3 className="font-heading text-base font-semibold text-foreground-950">
              Saved 10 Hours Weekly
            </h3>
            <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
              The itaobuyspreadsheet system completely changed how I approach product research. Instead of jumping between 15 different tabs, I now have everything in one structured view. My sourcing speed literally tripled within the first week.
            </p>
            <div className="flex items-center gap-3 mt-5 pt-4 border-t border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20male%20portrait%20headshot%20with%20short%20dark%20hair%20warm%20studio%20lighting%20minimal%20cream%20background%20clean%20modern%20photography%20friendly%20confident%20expression%20business%20casual%20attire%20natural%20pose&width=80&height=80&seq=av-v2-r1&orientation=squarish"
                alt="Marcus Chen"
                className="w-10 h-10 rounded-full object-cover"
              />
              <div>
                <div className="text-sm font-semibold text-foreground-950">
                  Marcus Chen
                </div>
                <div className="text-xs text-foreground-500">
                  Amazon FBA Seller
                </div>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-xl p-6 border border-background-200/60">
            <div className="flex items-center gap-0.5 mb-4">
              {[...Array(5)].map((_, i) => (
                <i
                  key={i}
                  className="ri-star-fill text-accent-500 w-4 h-4 flex items-center justify-center text-sm"
                ></i>
              ))}
            </div>
            <h3 className="font-heading text-base font-semibold text-foreground-950">
              Found 3 Winning Products
            </h3>
            <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
              I was struggling with scattered data across too many platforms. After switching to the itaobuy spreadsheet system, I identified three profitable products in just two days. The structured comparison feature is a game changer.
            </p>
            <div className="flex items-center gap-3 mt-5 pt-4 border-t border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Friendly%20female%20professional%20portrait%20with%20wavy%20blonde%20hair%20warm%20studio%20lighting%20minimal%20beige%20background%20clean%20modern%20headshot%20photography%20genuine%20smile%20approachable%20expression%20casual%20professional%20attire&width=80&height=80&seq=av-v2-r2&orientation=squarish"
                alt="Sarah Mitchell"
                className="w-10 h-10 rounded-full object-cover"
              />
              <div>
                <div className="text-sm font-semibold text-foreground-950">
                  Sarah Mitchell
                </div>
                <div className="text-xs text-foreground-500">
                  Dropshipping Entrepreneur
                </div>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-xl p-6 border border-background-200/60">
            <div className="flex items-center gap-0.5 mb-4">
              {[...Array(5)].map((_, i) => (
                <i
                  key={i}
                  className="ri-star-fill text-accent-500 w-4 h-4 flex items-center justify-center text-sm"
                ></i>
              ))}
            </div>
            <h3 className="font-heading text-base font-semibold text-foreground-950">
              Cut Sourcing Costs by 40%
            </h3>
            <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
              The price intelligence tracking in itaobuyspreadsheet helped me negotiate better deals with suppliers. Being able to compare pricing trends across multiple sources saved my business thousands in procurement costs.
            </p>
            <div className="flex items-center gap-3 mt-5 pt-4 border-t border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Confident%20Asian%20male%20professional%20portrait%20with%20stylish%20glasses%20warm%20studio%20lighting%20minimal%20cream%20background%20clean%20modern%20headshot%20photography%20friendly%20smile%20smart%20casual%20blazer&width=80&height=80&seq=av-v2-r3&orientation=squarish"
                alt="David Park"
                className="w-10 h-10 rounded-full object-cover"
              />
              <div>
                <div className="text-sm font-semibold text-foreground-950">
                  David Park
                </div>
                <div className="text-xs text-foreground-500">
                  Wholesale Importer
                </div>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-xl p-6 border border-background-200/60">
            <div className="flex items-center gap-0.5 mb-4">
              {[...Array(5)].map((_, i) => (
                <i
                  key={i}
                  className="ri-star-fill text-accent-500 w-4 h-4 flex items-center justify-center text-sm"
                ></i>
              ))}
            </div>
            <h3 className="font-heading text-base font-semibold text-foreground-950">
              Scaled Client Workflows
            </h3>
            <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
              Managing product sourcing for 12 clients was overwhelming until I discovered the itaobuy spreadsheet tool. Now each client has a dedicated tracking sheet, and my team can collaborate seamlessly on sourcing decisions.
            </p>
            <div className="flex items-center gap-3 mt-5 pt-4 border-t border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20Latina%20woman%20portrait%20with%20dark%20curly%20hair%20warm%20studio%20lighting%20minimal%20cream%20background%20clean%20modern%20headshot%20photography%20confident%20friendly%20smile%20elegant%20business%20attire&width=80&height=80&seq=av-v2-r4&orientation=squarish"
                alt="Emma Rodriguez"
                className="w-10 h-10 rounded-full object-cover"
              />
              <div>
                <div className="text-sm font-semibold text-foreground-950">
                  Emma Rodriguez
                </div>
                <div className="text-xs text-foreground-500">
                  E-commerce Agency Owner
                </div>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-xl p-6 border border-background-200/60">
            <div className="flex items-center gap-0.5 mb-4">
              {[...Array(5)].map((_, i) => (
                <i
                  key={i}
                  className="ri-star-fill text-accent-500 w-4 h-4 flex items-center justify-center text-sm"
                ></i>
              ))}
            </div>
            <h3 className="font-heading text-base font-semibold text-foreground-950">
              Eliminated Manual Errors
            </h3>
            <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
              Before itaobuyspreadsheet, I relied on manual Excel sheets that were prone to formula errors and version conflicts. The structured data intelligence system gave me confidence that every number is accurate and up to date.
            </p>
            <div className="flex items-center gap-3 mt-5 pt-4 border-t border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Mature%20male%20professional%20portrait%20with%20salt%20and%20pepper%20beard%20warm%20studio%20lighting%20minimal%20beige%20background%20clean%20modern%20headshot%20photography%20approachable%20wise%20expression%20business%20casual%20button%20down&width=80&height=80&seq=av-v2-r5&orientation=squarish"
                alt="James Walker"
                className="w-10 h-10 rounded-full object-cover"
              />
              <div>
                <div className="text-sm font-semibold text-foreground-950">
                  James Walker
                </div>
                <div className="text-xs text-foreground-500">
                  Product Researcher
                </div>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-xl p-6 border border-background-200/60">
            <div className="flex items-center gap-0.5 mb-4">
              {[...Array(5)].map((_, i) => (
                <i
                  key={i}
                  className="ri-star-fill text-accent-500 w-4 h-4 flex items-center justify-center text-sm"
                ></i>
              ))}
            </div>
            <h3 className="font-heading text-base font-semibold text-foreground-950">
              Launched My Store Faster
            </h3>
            <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
              I went from idea to launch in under three weeks thanks to the efficient product sourcing workflows built into the itaobuy spreadsheet system. The export feature integrates perfectly with my store backend.
            </p>
            <div className="flex items-center gap-3 mt-5 pt-4 border-t border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Young%20female%20professional%20portrait%20with%20red%20hair%20and%20freckles%20soft%20natural%20studio%20lighting%20minimal%20cream%20background%20modern%20clean%20headshot%20photography%20genuine%20warm%20smile%20creative%20casual%20attire&width=80&height=80&seq=av-v2-r6&orientation=squarish"
                alt="Lisa Thompson"
                className="w-10 h-10 rounded-full object-cover"
              />
              <div>
                <div className="text-sm font-semibold text-foreground-950">
                  Lisa Thompson
                </div>
                <div className="text-xs text-foreground-500">
                  Online Boutique Owner
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}